import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-603e33e9"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-newspaper me-2" }, null, -1))
const _hoisted_2 = { class: "px-3" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = {
  key: 0,
  class: "invalid-feedback d-inline",
  role: "alert"
}
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = {
  key: 0,
  class: "invalid-feedback d-inline",
  role: "alert"
}
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "active",
  class: "form-label text-muted"
}, " ปักหมุด: ", -1))
const _hoisted_9 = { class: "form-check form-switch" }
const _hoisted_10 = {
  class: "form-check-label",
  for: "active"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-trash-alt" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-ban" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-save" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseModalComponent = _resolveComponent("BaseModalComponent")!

  return (_openBlock(), _createBlock(_component_BaseModalComponent, {
    ref: "announcementForm",
    backdrop: "static",
    onHide: _ctx.clearForm,
    onHidden: _ctx.handleHidden
  }, {
    title: _withCtx(() => [
      _hoisted_1,
      _createTextVNode(_toDisplayString(_ctx.title), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", {
            for: "title",
            class: _normalizeClass(["form-label text-muted", {'is-invalid': _ctx.submited && _ctx.errors.title}])
          }, " หัวข้อข่าว: ", 2),
          (_ctx.submited && _ctx.errors.title)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, " * กรุณาเลือกชื่อหัวข้อข่าว "))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.title) = $event)),
            class: _normalizeClass(["form-control", {'is-invalid': _ctx.submited && _ctx.errors.title}]),
            placeholder: "กรุณาป้อนชื่อหัวข้อข่าว...",
            "aria-label": "title",
            autocomplete: "off",
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.unsubmit && _ctx.unsubmit(...args)))
          }, null, 34), [
            [
              _vModelText,
              _ctx.formData.title,
              void 0,
              { trim: true }
            ]
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("label", {
            for: "content",
            class: _normalizeClass(["form-label text-muted", {'is-invalid': _ctx.submited && _ctx.errors.content}])
          }, " เนื้อหาข่าว: ", 2),
          (_ctx.submited && _ctx.errors.content)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, " * กรุณาป้อนเนื้อหาข่าว "))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("textarea", {
            class: _normalizeClass(["form-control", {'is-invalid': _ctx.submited && _ctx.errors.content}]),
            placeholder: "กรุณาป้อนเนื้อหาข่าว...",
            "aria-label": "content",
            rows: "5",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.content) = $event)),
            onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.unsubmit && _ctx.unsubmit(...args)))
          }, "\n          ", 34), [
            [
              _vModelText,
              _ctx.formData.content,
              void 0,
              { trim: true }
            ]
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              type: "checkbox",
              id: "active",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.pined) = $event)),
              onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.unsubmit && _ctx.unsubmit(...args)))
            }, null, 544), [
              [_vModelCheckbox, _ctx.formData.pined]
            ]),
            _createElementVNode("label", _hoisted_10, _toDisplayString((_ctx.formData.pined) ? 'ตรึงข้อมูลไว้ด้านบน' : 'ปกติ'), 1)
          ])
        ])
      ])
    ]),
    footer: _withCtx(() => [
      (_ctx.isEditMode)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "btn btn-danger me-auto",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.deleteClick && _ctx.deleteClick(...args)))
          }, [
            _hoisted_11,
            _createTextVNode(" ลบ ")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-secondary",
        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)))
      }, [
        _hoisted_12,
        _createTextVNode(" ปิด ")
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary",
        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.submitClick && _ctx.submitClick(...args)))
      }, [
        _hoisted_13,
        _createTextVNode(" บันทึก ")
      ])
    ]),
    _: 1
  }, 8, ["onHide", "onHidden"]))
}